import React from "react";
import ReactDOM from 'react-dom';
import HubspotForm from 'react-hubspot-form'
import SalesForceForms from "./SalesForceForms";

export default function ContactUsModal() {
    return (
      <div>
        <div
          className="modal fade"
          id="contact-us-modal"
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: "700px" }}
          >
            <div className="modal-content">
              <div className="modal-header pb-0 border-none">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body px-5">
                <h5 className="font-supersized font-weight-bold mb-4">
                  Contact Us
                </h5>
                <HubspotForm
                  portalId="6893926"
                  formId="85b3258c-5277-4da9-b38d-c8d52eb4fc4c"
                  onSubmit={() => console.log("Submit!")}
                  onReady={(form) => console.log("Form ready!")}
                  region="na1"
                  loading={<p className="body-text-color">Loading...</p>}
                />
              </div>
            </div>
          </div>
        </div>

        {/* island company */}
        <div
          className="modal fade"
          id="contact-islandcompany-modal"
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: "700px" }}
          >
            <div className="modal-content">
              <div className="modal-header pb-0 border-none">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body px-5">
                <h5 className="font-supersized font-weight-bold mb-4">
                  Contact Us
                </h5>
                <HubspotForm
                  portalId="6893926"
                  formId="167eb6ed-b72e-4a03-b742-3b5f0d6e940a"
                  onSubmit={() => console.log("Submit!")}
                  onReady={(form) => console.log("Form ready!")}
                  region="na1"
                  loading={<p className="body-text-color">Loading...</p>}
                />
              </div>
            </div>
          </div>
        </div>

        {/* salesforce Forms */}
        <SalesForceForms />

        {/* exclusive island tours */}
        <div
          className="modal fade"
          id="contact-exclusiveislandtours-modal"
          tabIndex="-1"
          role="dialog"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: "700px" }}
          >
            <div className="modal-content" style={{ backgroundColor: '#FDF6ED' }}>
              <div className="modal-header pb-0 border-none">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body px-5">
                <h5 className="font-supersized font-weight-bold mb-4">
                  Contact Us
                </h5>
                <HubspotForm
                  portalId="6893926"
                  formId="565cf326-5ecb-4125-8775-d2ec7bea52fa"
                  onSubmit={() => console.log("Submit!")}
                  onReady={(form) => console.log("Form ready!")}
                  region="na1"
                  loading={<p className="body-text-color">Loading...</p>}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}


if (document.getElementById('contactUsMenu')) {
    
    const element = document.getElementById('contactUsMenu');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);   
    
    ReactDOM.render(<ContactUsModal data={JSON.parse(data.data)} />, document.getElementById('contactUsMenu'));
}


// WEBPACK FOOTER //
// ./resources/js/components/ContactUsModal/index.js